import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_USER_ROUND_X: GlameraIconDefinition = {
  name: 'user-round-x',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-user-round-x-body" d="M2 21a8 8 0 0 1 11.873-7"></path>
    <circle class="glm-user-round-x-head" cx="10" cy="8" r="5"></circle>
    <g class="glm-user-round-x-cross">
      <path class="glm-user-round-x-cross-line" d="m17 17 5 5"></path>
      <path class="glm-user-round-x-cross-line" d="m22 17-5 5"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-user-round-x-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './user-round-x.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserRoundXIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_USER_ROUND_X;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
